var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgZoomIn = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1C14 0.447715 14.4477 0 15 0L19.5 1.78814e-07C20.6046 2.38419e-07 21.5 0.895431 21.5 2V6.5C21.5 7.05229 21.0523 7.5 20.5 7.5C19.9477 7.5 19.5 7.05229 19.5 6.5V2L15 2C14.4477 2 14 1.55228 14 1ZM0.5 2C0.5 0.895431 1.39543 2.38419e-07 2.5 2.38419e-07H7C7.55228 2.38419e-07 8 0.447715 8 1C8 1.55228 7.55228 2 7 2H2.5V6.5C2.5 7.05229 2.05228 7.5 1.5 7.5C0.947715 7.5 0.5 7.05229 0.5 6.5V2ZM1.5 13.5C2.05229 13.5 2.5 13.9477 2.5 14.5L2.5 19L7 19C7.55229 19 8 19.4477 8 20C8 20.5523 7.55228 21 7 21L2.5 21C1.39543 21 0.5 20.1046 0.5 19L0.500001 14.5C0.500001 13.9477 0.947716 13.5 1.5 13.5ZM20.5 13.5C21.0523 13.5 21.5 13.9477 21.5 14.5V19C21.5 20.1046 20.6046 21 19.5 21H15C14.4477 21 14 20.5523 14 20C14 19.4477 14.4477 19 15 19H19.5V14.5C19.5 13.9477 19.9477 13.5 20.5 13.5Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZoomIn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/zoomIn.bf47413ea3db7814f27ff8c6c3ae7818.svg";